import styled, { css } from 'styled-components';
import { variant } from 'styled-system';
import themeUtilities from '../../../../theme/ThemeUtilities';
import { RowVariant } from '../types';

export const TableRow = styled.tr<{
  variant?: RowVariant;
  disableBorder?: boolean;
}>`
  display: flex;
  flex: 1;
  transition: background-color 0.1s;
  will-change: background-color;

  ${(props) =>
    variant(themeUtilities.getComponentVariant(props, 'Table', 'row'))};
  ${(props) =>
    props.disableBorder &&
    css`
      border: none;
    `};
`;
TableRow.defaultProps = {
  variant: 'body',
};
